export { SearchPageView as default } from './SearchPageView';
